var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute left-0 top-full py-8 w-full bg-white shadow-lg"},[_c('div',{staticClass:"container px-4 mx-auto"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }